import React from 'react'

const Database = () => {
  return (
    <div className="skills_content">
      <h3 className="skills_title"> <i class='bx bx-data'></i>  Database</h3>

      <div className="skills_list">
        <div className="skills_item">SQL Server</div>
        <div className="skills_item"> MySQL</div>
        <div className="skills_item"> PostgreSQL</div>
        <div className="skills_item"> Oracle</div>
      </div>
    </div>
  )
}

export default Database